import _isNull from "lodash/isNull";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import Browser from "./Browser";
// Get time.
function getCurrentTime() {
  return Math.round(new Date().getTime() / 1000);
}

// Get expire time from ttl.
function getExpireTime(ttl) {
  return getCurrentTime() + ttl;
}

// Get the storage key for the current market.
function getCountryKey(key, country) {
  return "".concat(country, "_").concat(key);
}

// Store a value in cookie.
function setCookieValue(key, value, expire) {
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  var valueString = "".concat(key, "=").concat(JSON.stringify(value), "; ");
  var expirationDate = new Date(expire * 1000);
  var expireString = expire ? "expires=".concat(expirationDate.toUTCString(), "; ") : '';
  var pathString = "path=".concat(path);
  if (Browser.isBrowser()) {
    document.cookie = "".concat(valueString).concat(expireString).concat(pathString);
  }
  return true;
}

// Get a value from cookie.
function getCookieValue(key) {
  var json = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var name = "".concat(key, "=");
  var cookies = Browser.isBrowser() ? document.cookie.split(';') : [];
  var cookieValue = null;
  cookies.forEach(function (item) {
    var cookie = item.trim();
    if (cookie.indexOf(name) === 0) {
      var strValue = cookie.substring(name.length, cookie.length);
      cookieValue = json ? JSON.parse(strValue) : strValue;
    }
  });
  return cookieValue;
}
function setLocalStorageValue(key, value, expire) {
  var storageObject = {
    expire: expire,
    value: value
  };
  try {
    if (Browser.isBrowser()) {
      window.localStorage.setItem(key, JSON.stringify(storageObject));
    }
  } catch (ex) {
    // If local storage is not supported by the browser, then just return false.
    // This is most likely to happen in Safari Private browsing.
    return false;
  }
  return true;
}

// Get a value from local storage.
function getLocalStorageValue(key) {
  var value = Browser.isBrowser() ? window.localStorage.getItem(key) : null;
  var storageObject = value ? JSON.parse(value) : null;

  // If the storage object is found.
  if (storageObject) {
    // If this storage object has expired, return null.
    var currentTime = getCurrentTime();
    if (storageObject.expire < currentTime) {
      return null;
    }

    // Return the stored value.
    return storageObject.value;
  }
  return null;
}

// Store a value in browser storage.
function setItem(key, value, country) {
  var ttl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 86400;
  // Get the key for the current country.
  var fullKey = getCountryKey(key, country);

  // Calculation the expiration time in seconds.
  var expire = getExpireTime(ttl);

  // Store the value.
  var success = setLocalStorageValue(fullKey, value, expire);

  // If local storage failed, try storing it in a cookie.
  if (!success) {
    success = setCookieValue(fullKey, value, expire);
  }
  return success;
}

// Get a value from browser.
function getItem(key, country) {
  // Get the key for the current country.
  var fullKey = getCountryKey(key, country);

  // Get the value.
  var value = getLocalStorageValue(fullKey);

  // If local storage failed, try getting it from a cookie.
  if (_isNull(value)) {
    value = getCookieValue(fullKey);
  }
  return value;
}
var Storage = {
  setItem: setItem,
  getItem: getItem,
  setCookieValue: setCookieValue,
  getCookieValue: getCookieValue,
  getExpireTime: getExpireTime
};
export default Storage;